export default "<ion-spinner name=\"crescent\" class=\"loader\"></ion-spinner>"